import { VerifyId } from '@illustrations';
import React from 'react';
import { useTheme } from 'styled-components';
import { Button, Typography } from '@ui';
import { useIntl } from 'react-intl';
import { useHistory } from 'react-router-dom';

const ProviderEmpty: React.FunctionComponent = () => {
  const theme = useTheme();
  const { formatMessage } = useIntl();
  const history = useHistory();

  return (
    <>
      <div style={{ display: 'flex', justifyContent: 'center' }}>
        <VerifyId />
      </div>
      <Typography
        display="h3"
        align="center"
        style={{
          padding: `0 ${theme.spacings.component.S}px`,
          marginTop: theme.spacings.text.XL,
          marginBottom: theme.spacings.text.M,
        }}
      >
        {formatMessage({ id: 'provider.onboarding.empty.title' })}
      </Typography>
      <Typography
        display="h6"
        align="center"
        style={{
          color: theme.color.tint.secondary,
          padding: `0 ${theme.spacings.component.S}px`,
        }}
      >
        {formatMessage({ id: 'provider.onboarding.empty.description' })}
      </Typography>
      <div
        style={{
          marginTop: theme.spacings.text.XL,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
        }}
      >
        <Button
          style={{ maxWidth: 343 }}
          block={false}
          rightArrow
          onClick={() => history.push('/create-provider')}
        >
          {formatMessage({ id: 'provider.onboarding.create.new' })}
        </Button>
      </div>
    </>
  );
};

export default ProviderEmpty;
